import BackgroundColors from '@root/joinroot.com/src/utils/background-colors';
import Colors from '@root/joinroot.com/src/utils/colors';
import PropTypes from '@root/vendor/prop-types';
import Responsive from '@root/core/src/utils/responsive';
import { Alignments, SizesSML } from '@root/contentful/src/models/contentful-constants';
import { Eyebrow, H1Display, P1, Subhead } from '@root/joinroot.com/src/components/text';
import { StyleSheet } from '@root/core/src/utils/styles';

export default function HeroSimpleSection({
  alignmentX, anchor, backgroundColor, body, eyebrow, headline, icon, iconAlt, iconSize = SizesSML.S, subhead,
}) {
  return (
    <section
      css={[
        styles.section,
        BackgroundColors.getBackgroundStyle(backgroundColor),
      ]}
      data-testid={'hero-simple'}
      id={anchor}
    >
      <div
        css={[
          styles.container,
          alignmentX === Alignments.CENTER && styles.containerCenter,
        ]}
        data-testid={'hero-simple-container'}
      >
        {icon &&
        <img
          alt={iconAlt}
          css={[styles.icon, styles[`icon${iconSize}`]]}
          data-testid={'hero-simple-icon'}
          src={icon}
        />
        }
        {eyebrow && <Eyebrow css={styles.eyebrow}>{eyebrow}</Eyebrow>}
        {headline && <H1Display css={styles.headline}>{headline}</H1Display>}
        {subhead && <Subhead css={styles.subhead}>{subhead}</Subhead>}
        {body && <P1 css={styles.bodyText}>{body}</P1>}
      </div>
    </section>
  );
}

HeroSimpleSection.propTypes = {
  alignmentX: PropTypes.oneOf([Alignments.CENTER, Alignments.LEFT]).isRequired,
  anchor: PropTypes.string,
  backgroundColor: PropTypes.oneOf(BackgroundColors.cmsValueList).isRequired,
  body: PropTypes.string,
  eyebrow: PropTypes.string,
  headline: PropTypes.string.isRequired,
  icon: PropTypes.string,
  iconAlt: PropTypes.string,
  iconSize: PropTypes.oneOf(Object.values(SizesSML)),
  subhead: PropTypes.string,
};

const styles = StyleSheet.create({
  section: {
    padding: '40px 20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    ...Responsive.md({
      padding: '50px 20px',
    }),
  },
  container: {
    width: '100%',
    maxWidth: 800,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'left',
  },
  containerCenter: {
    alignItems: 'center',
    textAlign: 'center',
  },
  icon: {
    marginBottom: 20,
  },
  iconS: {
    height: 24,
    width: 24,
  },
  iconM: {
    height: 48,
    width: 48,
  },
  iconL: {
    height: 70,
    width: 70,
  },
  eyebrow: {
    marginBottom: 20,
  },
  headline: {
    fontSize: 40,
    ...Responsive.md({
      fontSize: 45,
    }),
  },
  subhead: {
    marginTop: 20,
    'p, a': {
      color: Colors.grayDark(),
      fontSize: 20,
    },
  },
  bodyText: {
    marginTop: 20,
  },
});
